export default __webpack_public_path__ + "static/media/blu_log.b1a666f9.svg";